import React, { useState } from "react";
import qrIcon from "../img/qr.png";
import uploadIcon from "../img/upload.svg";
import PopUp from "./popUp";

function DocFooter() {
  const [showPopUp, setShowPopUp] = useState(false);

  const handleShowQR = () => {
    setShowPopUp(true);
  };

  const handleShare = async () => {
    const savedImage = localStorage.getItem("uploadedImage");
    if (savedImage) {
      try {
        const blob = await fetch(savedImage).then((res) => res.blob()); 

        await navigator.share({
          title: "Поделиться изображением",
          text: "Я хочу поделиться изображением с вами!",
          files: [new File([blob], "document.jpg", { type: "image/jpeg" })], 
        });

        console.log("Успешно поделились!");
      } catch (error) {
        console.error("Ошибка при попытке поделиться:", error);
      }
    } else {
      console.error("Нет изображения для отправки.");
    }
  };

  return (
    <div className="footer">
      <div className="btnfooter" id="docbtn">
        <button id="btnftr1" onClick={handleShowQR}>
          <img src={qrIcon} alt="" />
          Предъявить документ
        </button>
        <button id="btnftr2" className="share" onClick={handleShare}>
          <img src={uploadIcon} alt="" />
          Отправить документ
        </button>
      </div>
      {showPopUp && <PopUp onClose={() => setShowPopUp(false)} />}
    </div>
  );
}

export default DocFooter;
